import React, { useEffect, useState } from "react";
import Product from "./Product";
import { CircularProgress, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useRequest } from "../../hooks/useRequest/useRequest";
import { AiOutlineClose } from "react-icons/ai";
import Slider from "react-slick";
import { REQUEST_STATUS } from "../../hooks/useRequest/useRequest.constants";
import Loader from "../../components/Loader/Loader";
import { Stack } from "@mui/system";
import "./productPage.css";
import { IMG_URL } from "../../api/imgApi/ImgApi";

const Products = () => {
  const [isModalImages, setIsModalImages] = useState<boolean>(false);
  const [productId, setProductId] = useState<string>("");
  const [modalImages, setModalImages] = useState<any>([]);
  const defaultLimit = 15;
  const [limit, setLimit] = useState(defaultLimit);

  const [getProductClient, getProductData, getProductStatus] = useRequest();

  const lang: any = localStorage.getItem("i18nextLng");

  let { categoryId } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  const getProduct = () => {
    getProductClient.post("product/pagin", {
      page: 1,
      limit,
      categoryId,
    });
  };

  useEffect(() => {
    getProduct();
  }, [limit]);

  useEffect(() => {
    let selected = getProductData?.data?.data?.find(
      (item: any) => item._id === productId
    );

    setModalImages(selected?.image);
  }, [productId]);

  const settings = {
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    appendDots: (dots: any) => (
      <div className="slickDots">
        <ul className="oneDot"> {dots} </ul>
      </div>
    ),
    customPaging: (i: any) => <div className="myDot"></div>,
  };

  return (
    <>
      <div className="products_container">
        <div className="products_page_header">
          <h2>{t("ALLPRODUCTS.TITLE")}</h2>
        </div>

        <div className="products_content">
          <div className="products_header">
            <div className="products_title">
              <div className="categorys_title">
                {getProductData?.data?.data[0]?.category?.name?.[lang]}
              </div>
            </div>
          </div>
          <div className="my_products">
            {getProductStatus === REQUEST_STATUS.loading && <Loader />}
            {getProductData?.data?.data?.map((item: any) => (
              <Product
                setIsModalImages={setIsModalImages}
                item={item}
                setProductId={setProductId}
                key={item._id}
              />
            ))}
            {getProductData?.data?.data.length === 0 && (
              <h1 className="no_products">Prodaktlar mavjud emas</h1>
            )}
          </div>

          <div className="yuklash_btn_box">
            {getProductData?.data?.data?.length >= limit ? (
              <button
                onClick={() => setLimit((prev) => prev + defaultLimit)}
                className="yuklash_btn"
              >
                {getProductData === REQUEST_STATUS.success ? (
                  <Stack sx={{ color: "#ffffff" }} spacing={2} direction="row">
                    <CircularProgress color="inherit" size="20px" />
                  </Stack>
                ) : (
                  t("ALLPRODUCTS.BTNTITLE")
                )}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <div className={isModalImages ? "images_modal active" : "images_modal"}>
        <IconButton
          onClick={() => setIsModalImages(false)}
          className="modal_image_close"
        >
          <AiOutlineClose className="modal_close_icon" />
        </IconButton>

        <div className="my_image_modal_content">
          <Slider {...settings} className="my_slide">
            {modalImages?.map((item: any) => (
              <div className="modal_img">
                <img src={IMG_URL + item.url} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Products;
